import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Field } from '../Field'
import { schoolApi } from '../../api/school'
import { ApiError } from '../../api/client'

/**
 * Экран для учителя без школы: две карточки —
 * «Создать школу» (открывает диалог) и «Присоединиться по токену».
 */
export function NoSchool({
  onCreate,
  joinToken,
  setJoinToken,
}: {
  onCreate: () => void
  joinToken: string
  setJoinToken: (s: string) => void
}) {
  const { t } = useTranslation()
  const [joining, setJoining] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleJoin = async () => {
    if (!joinToken.trim()) return
    setError(null)
    setJoining(true)
    try {
      await schoolApi.joinByToken(joinToken.trim())
      window.location.reload()
    } catch (e) {
      setError((e as ApiError).message)
    } finally {
      setJoining(false)
    }
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="bg-white border border-purple-100/80 rounded-2xl p-6">
        <div className="text-4xl mb-3">🏫</div>
        <h3 className="font-semibold text-gray-900 mb-2">{t('noSchool.createTitle')}</h3>
        <p className="text-sm text-gray-600 mb-4">
          {t('noSchool.createText')}
        </p>
        <button onClick={onCreate} className="btn-primary text-sm">
          {t('noSchool.createButton')}
        </button>
      </div>

      <div className="bg-white border border-purple-100/80 rounded-2xl p-6">
        <div className="text-4xl mb-3">🔗</div>
        <h3 className="font-semibold text-gray-900 mb-2">{t('noSchool.joinTitle')}</h3>
        <p className="text-sm text-gray-600 mb-4">
          {t('noSchool.joinText')}
        </p>
        <Field label={t('noSchool.tokenLabel')}>
          <input
            className="input-field"
            placeholder="abc123-..."
            value={joinToken}
            onChange={(e) => setJoinToken(e.target.value)}
          />
        </Field>
        {error && <div className="text-sm text-red-600 mb-3">{error}</div>}
        <button
          onClick={handleJoin}
          disabled={joining || !joinToken.trim()}
          className="btn-primary text-sm"
        >
          {joining ? t('noSchool.joining') : t('noSchool.joinButton')}
        </button>
      </div>
    </div>
  )
}
